import { styled } from "styled-components";

import { colorsPalettes } from "@similarweb/styles";
import { TitlePlaceholderLoader } from "@similarweb/ui-components";
import { Stack } from "@similarweb/ui-components/foundations";

import { integrationMaxWidth } from "../../../manage-export/style";

export const StyledTeamsManagementContainer = styled(Stack)`
    ${integrationMaxWidth};
    min-width: 0;
    min-height: 0;
    height: 100%;
`;

export const StyledTabsWrapper = styled.div`
    li {
        background-color: ${colorsPalettes.carbon["0"]};
        margin: 0;
        text-transform: none;
    }

    li:first-of-type {
        border-left: none;
        border-radius: 6px 0 0 6px;
    }

    li:last-of-type {
        border-left: none;
        border-radius: 0 6px 6px 0;
    }

    li:first-of-type:last-of-type {
        border-radius: 6px;
    }
`;

export const StyledTabValueLoader = styled(TitlePlaceholderLoader)`
    height: 16px;
    width: 64px;
`;
